import { FC, MouseEventHandler } from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import SaveSvg from '../../../public/images/common/bookmark_save_icon.svg'
import SavedSvg from '../../../public/images/common/bookmark_saved_icon.svg'
import { LoadingIndicator } from '../../atoms/LoadingIndicator'
import styles from './index.module.scss'

type Props = {
  isSaved: boolean
  disabled?: boolean
  isLoading?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export const SaveJobButtonIcon: FC<Props> = observer(
  ({ disabled = false, isLoading = false, isSaved = false, onClick }) => {
    const renderContent = () => {
      if (isLoading) {
        return <LoadingIndicator size='small' color='gray' />
      }
      if (isSaved) {
        return <SavedSvg />
      }
      return <SaveSvg />
    }

    return (
      <button
        type='button'
        className={classNames(styles.container, {
          [styles.disabledContainer]: disabled,
          [styles.loadingContainer]: isLoading,
          [styles.savedContainer]: !isLoading && isSaved,
        })}
        onClick={onClick}
        disabled={disabled}
      >
        <div
          className={classNames(styles.inner, {
            [styles.savedSvgInner]: !isLoading && isSaved,
            [styles.saveSvgInner]: !isLoading && !isSaved,
          })}
        >
          {renderContent()}
        </div>
      </button>
    )
  }
)
